"use strict";
'use client';
exports.__esModule = true;
exports.Modal = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var div_1 = tslib_1.__importDefault(require("../div"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var modal_style_1 = require("./modal.style");
var Modal = function (_a) {
    var open = _a.open, _b = _a.position, position = _b === void 0 ? 'float' : _b, _c = _a.hasBorder, hasBorder = _c === void 0 ? false : _c, _d = _a.borderColor, borderColor = _d === void 0 ? 'primary' : _d, children = _a.children, onClose = _a.onClose, className = _a.className, wrapperClassName = _a.wrapperClassName, rest = tslib_1.__rest(_a, ["open", "position", "hasBorder", "borderColor", "children", "onClose", "className", "wrapperClassName"]);
    (0, react_1.useEffect)(function () {
        open ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'unset';
    }, [open]);
    if (open && position === 'float') {
        return (react_1["default"].createElement(div_1["default"], { className: (0, class_names_1["default"])("justify-center items-center bg-black/[0.4] backdrop-blur-sm fixed top-0 left-0 right-0 z-[1300] w-full h-dvh", className) },
            react_1["default"].createElement(div_1["default"], tslib_1.__assign({ className: "-z-10 w-screen h-dvh absolute", onClick: onClose }, rest)),
            children));
    }
    if (open && position === 'bottom') {
        return (react_1["default"].createElement(div_1["default"], { className: (0, class_names_1["default"])("w-full h-dvh justify-center bg-black/[0.4] backdrop-blur-sm fixed top-0 left-0 right-0 z-[1300] items-end", className) },
            react_1["default"].createElement(div_1["default"], { onClick: onClose, className: '-z-10 w-screen h-dvh absolute' }),
            react_1["default"].createElement(div_1["default"], { className: (0, class_names_1["default"])('w-full h-auto rounded-tr-2xl rounded-tl-2xl justify-center overflow-hidden', modal_style_1.BORDER_COLOR[borderColor], hasBorder ? 'border-2 border-b-0 border-x-0' : 'border-0', wrapperClassName) }, children)));
    }
    return null;
};
exports.Modal = Modal;
exports["default"] = exports.Modal;
//# sourceMappingURL=modal.js.map